// extracted by mini-css-extract-plugin
export default {"rate":"GameRate_rate__nuKqF"};